






import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import Loading from 'vue-loading-overlay';
import pricingServices from '@/services/pricing-services';
import ListPricing from './ListPricing.vue';
import PricingDetail from './PricingDetail.vue';
import Paging from '@/shared/components/Paging.vue';
import commonService from '@/services/common-services';
@Component({
  components: {
    ListPricing,
    PricingDetail,
    Loading,
    Paging
  },
})
export default class MainPricing extends Vue {
    private isLoading = false;
    private searchTerm = '';
    private searchResult: any = null;
    private listItem: any[] = [];
    private listWeightPrice: any[] = [];
    private listVolumePrice: any[] = [];
    private pageSettings = {
        rowPerPage: 100,
        pageSize: 6,
        pageIndex: 1,
        total: 0,
    };
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    private async created() {
        await this.getConfiguration();
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        await this.loadData();
    }

    private async getConfiguration() {
        const result = await commonService.configuration();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
        }
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.searchResult = null;

        const result = await pricingServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage);
        
        if (result && result.data && result.data.status === 200) {
            this.pageSettings.total = result.data.total;
            this.listItem = result.data.data;
        }
        this.isLoading = false;
    }

    private async onViewDetail(id) {
        this.isLoading = true;
        const result = await pricingServices.getDetail(id);
        if (result && result.data && result.data.status === 200) {
            this.listWeightPrice = result.data.data.list_weight_price;
            this.listVolumePrice = result.data.data.list_volume_price;
        }
        this.isLoading = false;
    }
}
